import { render, staticRenderFns } from "./acvitityFoot.vue?vue&type=template&id=79a04434&scoped=true&"
import script from "./acvitityFoot.vue?vue&type=script&lang=js&"
export * from "./acvitityFoot.vue?vue&type=script&lang=js&"
import style0 from "./acvitityFoot.vue?vue&type=style&index=0&id=79a04434&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a04434",
  null
  
)

export default component.exports